var exports = {
  "k": "x04b3a21e--e724fd--container",
};

module.exports = exports;
